export default __webpack_public_path__ + "static/media/ic_upload-picture.db25ee04.svg";